export default "__VITE_ASSET__K_17EGJO__"